var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingToast),expression:"loadingToast"}],staticClass:"main-loading"},[_c('van-loading',{attrs:{"color":"white"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }